import env             from '../env';
import { UserSession } from '../types';
import segmentService  from '../services/SegmentService';

const global = (window as any);

export function startSegment() {
    /* tslint:disable */
    const analytics = global.analytics = global.analytics || []; if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error('Segment snippet included twice.'); else {
        analytics.invoked = !0; analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on']; analytics.factory = function (t) { return function () { let e = Array.prototype.slice.call(arguments); e.unshift(t); analytics.push(e); return analytics; }; }; for (let t = 0; t < analytics.methods.length; t++) { let e = analytics.methods[t]; analytics[e] = analytics.factory(e); } analytics.load = function (t) { let e = document.createElement('script'); e.type = 'text/javascript'; e.async = !0; e.src = ('https:' === document.location.protocol ? 'https://' : 'http://') + 'cdn.segment.com/analytics.js/v1/' + t + '/analytics.min.js'; let n = document.getElementsByTagName('script')[0]; n.parentNode.insertBefore(e, n); }; analytics.SNIPPET_VERSION = '4.0.0';
        analytics.load(env.SEGMENT_KEY);
    }
    /* tslint:enable */
}

export function trackMessage() {
    global.analytics && global.analytics.track('Activity performed',
        {
            activity: 'SMS sent',
            tracking_plan_id: '0001'
        },
        {
            app: {
                name: 'chat',
                version: '',
                build: env.BUILD
            }
        }
    );
}

export async function identifyUser(user: UserSession) {
    const data = await segmentService(user);
    global.analytics.identify(data.segmentData.user_id, data.segmentData, {
        Intercom: data.intercomData
    });
}



// WEBPACK FOOTER //
// ./src/helpers/segment.ts